<template>
  <div class="col-md-9 col-xl-7 position-static px-0 px-md-15 js-dropdowns">
    <div class="open-close-holder">
      <a
        href="#"
        class="advanced-search-opener nav-link d-flex justify-content-between align-items-center px-10 px-md-15 d-md-none"
      >
        Advanced search
        <span class="icon-chevron ml-10"></span>
      </a>
      <ul
        class="search-navigation nav-drop d-md-flex justify-content-between flex-wrap list-unstyled  mb-0"
      >
        <li class="nav-item open-close position-static">
          <a
            class="nav-link drop-opener d-flex justify-content-between align-items-center pl-20 pr-10 px-md-15"
            href="#"
          >
            Resource Type
            <span class="icon-chevron ml-10"></span>
          </a>
          <div class="dropdown bg-gray-2 pt-15 ">
            <div class="container">
              <form method="GET" class="secondary-form" v-on:submit.prevent="submit">
                <ul
                  class="check-list d-flex align-items-center flex-wrap list-unstyled mb-0"
                >
                  <li v-for="item in types" :key="item.id" class="pb-15">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="activeTypes"
                        :value="item"
                        :id="item.id"
                      />
                      <label class="custom-control-label" :for="item.id">{{item.name}}</label>
                    </div>
                  </li>
                </ul>
                <button type="submit" class="btn btn-primary w-100 py-5 secondary-search-btn">search</button>
              </form>
            </div>
          </div>
        </li>
        <li class="nav-item open-close">
          <a
            class="nav-link drop-opener d-flex justify-content-between align-items-center pl-20 pr-10 px-md-15"
            href="#"
          >
            Topics
            <span class="icon-chevron ml-10"></span>
          </a>
          <div class="dropdown bg-gray-2 pt-15">
            <div class="container">
              <form class="secondary-form" method="GET" v-on:submit.prevent="submit">
                <ul
                  class="check-list d-flex align-items-center flex-wrap list-unstyled mb-0"
                >
                  <li v-for="item in classifications" :key="item.id" class="pb-15">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="activeClassifications"
                        :value="item"
                        :id="item.id"
                        name="classifications[]"
                      />
                      <label class="custom-control-label" :for="item.id">{{item.name}}</label>
                    </div>
                  </li>
                </ul>
                <button type="submit" class="btn btn-primary w-100 py-5 secondary-search-btn">search</button>
              </form>
            </div>
          </div>
        </li>
        <li class="nav-item open-close">
          <a
            class="nav-link drop-opener d-flex justify-content-between align-items-center pl-20 pr-10 px-md-15"
            href="#"
          >
            Audience
            <span class="icon-chevron ml-10"></span>
          </a>
          <div class="dropdown bg-gray-2 pt-15">
            <div class="container">
              <form class="secondary-form" method="GET" v-on:submit.prevent="submit">
                <ul
                  class="check-list d-flex align-items-center flex-wrap list-unstyled mb-0"
                >
                  <li v-for="item in targets" :key="item.id" class="pb-15">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="activeTargets"
                        :value="item"
                        :id="item.id"
                      />
                      <label class="custom-control-label" :for="item.id">{{item.name}}</label>
                    </div>
                  </li>
                </ul>
                <button type="submit" class="btn btn-primary w-100 py-5 secondary-search-btn">search</button>
              </form>
            </div>
          </div>
        </li>
        <li class="nav-item open-close">
          <a
            class="nav-link drop-opener d-flex justify-content-between align-items-center pl-20 pr-10 px-md-15"
            href="#"
          >
            Language
            <span class="icon-chevron ml-10"></span>
          </a>
          <div class="dropdown bg-gray-2 pt-15 ">
            <div class="container">
              <form class="secondary-form" method="GET" v-on:submit.prevent="submit">
                <ul
                  class="check-list d-flex align-items-center flex-wrap list-unstyled mb-0"
                >
                  <li v-for="item in languages" :key="item.id" class="pb-15">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="activeLanguages"
                        :value="item"
                        :id="item.id"
                      />
                      <label class="custom-control-label" :for="item.id">{{item.name}}</label>
                    </div>
                  </li>
                </ul>
                <button type="submit" class="btn btn-primary w-100 py-5 secondary-search-btn">search</button>
              </form>
            </div>
          </div>
        </li>
        <li class="nav-item open-close">
          <a
            class="nav-link drop-opener d-flex justify-content-between align-items-center pl-20 pr-10 px-md-15"
            href="#"
          >
            Fluency
            <span class="icon-chevron ml-10"></span>
          </a>
          <div class="dropdown bg-gray-2 pt-15 ">
            <div class="container">
              <form class="secondary-form" method="GET" v-on:submit.prevent="submit">
                <ul
                  class="check-list d-flex align-items-center flex-wrap list-unstyled mb-0"
                >
                  <li v-for="item in fluencies" :key="item.id" class="pb-15">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="activeFluencies"
                        :value="item"
                        :id="item.id"
                      />
                      <label class="custom-control-label" :for="item.id">{{item.name}}</label>
                    </div>
                  </li>
                </ul>
                <button type="submit" class="btn btn-primary w-100 py-5 secondary-search-btn">search</button>
              </form>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped lang="scss">
</style>
<script>
import { mapState, mapGetters } from "vuex";
import * as utils from '../utils'

export default {
  computed: {
    ...mapState([
      "search_post_url",
      "types",
      "classifications",
      "targets",
      "languages",
      "fluencies"
    ]),
    ...mapGetters([
      "actionURL"
    ]),
    activeTypes: {
      get() {
        return this.$store.state.activeTypes;
      },
      set(value) {
        this.$store.commit("updateActiveTypes", value);
      }
    },
    activeClassifications: {
      get() {
        return this.$store.state.activeClassifications;
      },
      set(value) {
        this.$store.commit("updateActiveClassifications", value);
      }
    },
    activeTargets: {
      get() {
        return this.$store.state.activeTargets;
      },
      set(value) {
        this.$store.commit("updateActiveTargets", value);
      }
    },
    activeLanguages: {
      get() {
        return this.$store.state.activeLanguages;
      },
      set(value) {
        this.$store.commit("updateActiveLanguages", value);
      }
    },
    activeFluencies: {
      get() {
        return this.$store.state.activeFluencies;
      },
      set(value) {
        this.$store.commit("updateActiveFluencies", value);
      }
    }
  },

  methods: {
    submit () {
      window.location.href = this.actionURL;
    }
  }
};
</script>
